var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterVagueBleue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 394,
    height: 98.273,
    viewBox: "0 0 394 98.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "footer_vague_bleue",
    "data-name": "footer vague bleue",
    d: "M0,11.029V98.273H393.6L394,9.817s-31.106,29.563-199.227-.808C76.369-12.381,0,11.029,0,11.029",
    transform: "translate(0 0.001)",
    fill: "#1b9bd7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterVagueBleue);
export default __webpack_public_path__ + "static/media/footer_vague_bleue.0a25240a5eaba66420ab7aa96189b308.svg";
export { ForwardRef as ReactComponent };